/* ============================================================
   BEUTE.STUDIO — Premium Interactions (defer)
   Scroll-Progress, Reveals, Lazy-Fade, 3D-Tilt, Header-State
   ============================================================ */
(function () {
  'use strict';
  var w = window, d = document, de = d.documentElement;
  var reduced = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = w.Shopify && w.Shopify.designMode;

  de.classList.remove('no-js');
  de.classList.add('pv-ready');

  /* ── Lazy-Bilder sanft einblenden ── */
  function hookImg(img) {
    if (img.complete) { img.classList.add('pv-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('pv-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('pv-loaded'); }, { once: true });
  }
  Array.prototype.slice.call(d.querySelectorAll('img[loading="lazy"]')).forEach(hookImg);

  /* ── Scroll-Fortschrittsbalken ── */
  var bar = d.createElement('div');
  bar.id = 'beute-progress';
  d.body.appendChild(bar);

  /* ── Header-Zustand + Summer-Gradient + Progress in einem rAF-Loop ── */
  var hdr = d.getElementById('header');
  var grad = d.getElementById('summer-gradient');
  var ticking = false;
  function onScroll() {
    var s = w.scrollY;
    if (hdr) hdr.classList.toggle('scrolled', s > 60);
    if (grad) grad.style.transform = 'translateY(-' + Math.min(s / w.innerHeight * 100, 100) + '%)';
    var h = de.scrollHeight - w.innerHeight;
    bar.style.width = (h > 0 ? (s / h * 100) : 0) + '%';
    ticking = false;
  }
  w.addEventListener('scroll', function () {
    if (!ticking) { w.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  onScroll();

  /* ── Loader ausblenden ── */
  var loader = d.getElementById('loader');
  if (loader) {
    setTimeout(function () {
      loader.style.opacity = '0';
      loader.style.pointerEvents = 'none';
      setTimeout(function () { loader.remove(); }, 400);
    }, 0);
  }

  /* ── Scroll-Reveals mit Stagger (nur unterhalb des Folds) ── */
  if (!reduced && !designMode && 'IntersectionObserver' in w) {
    var targets = Array.prototype.slice.call(d.querySelectorAll('.pcard, .trust-item, .hero-cat, .hbcard'));
    var byParent = new Map();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('pv-in');
        obs.unobserve(el);
        var i = parseInt(el.style.getPropertyValue('--pv-i') || '0', 10);
        setTimeout(function () { el.classList.remove('pv'); }, 1100 + i * 70);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -36px 0px' });

    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < w.innerHeight * 0.92) return;
      var p = el.parentElement || d.body;
      var i = byParent.get(p) || 0;
      byParent.set(p, i + 1);
      el.style.setProperty('--pv-i', String(i % 8));
      el.classList.add('pv');
      obs.observe(el);
    });
  }

  /* ── 3D-Tilt auf Produktkarten (nur Desktop, sehr subtil) ── */
  if (!reduced && w.matchMedia('(pointer: fine)').matches) {
    Array.prototype.slice.call(d.querySelectorAll('.pcard')).forEach(function (card) {
      var raf = null;
      card.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = w.requestAnimationFrame(function () {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'perspective(900px) translateY(-6px) rotateX(' + (-y * 2.6).toFixed(2) + 'deg) rotateY(' + (x * 2.6).toFixed(2) + 'deg)';
          raf = null;
        });
      });
      card.addEventListener('pointerleave', function () {
        if (raf) { w.cancelAnimationFrame(raf); raf = null; }
        card.style.transform = '';
      });
    });
  }
})();
